export const RENEW_INVOICE = 'RENEW_INVOICE';
export const BASIC_FEE = "BASIC_FEE";
export const STANDARD ="STANDARD";
export const RENT_DAYS = "RENT_DAYS";